import { Section } from "..";
import SidebarSecondaryContent from "./SidebarSecondaryContent";
import SidebarPrimaryContent from "./SidebarPrimaryContent";
import HyroxUpgradeSection from "./components/HyroxUpgradeSection";

function SidebarContent() {
  return (
    <Section data-sidebar="content" sx={{ display: "flex", flexDirection: "column", flex: "1", gap: "16px" }}>
      <SidebarPrimaryContent />
      <HyroxUpgradeSection />
      <SidebarSecondaryContent />
    </Section>
  );
}

export default SidebarContent;
